export default {"src":"/_next/static/media/dedicated_icon.a32778d8.svg","height":92,"width":89,"blurWidth":0,"blurHeight":0};